import * as React from "react";
import {ShoppingBasket} from "../../models/ShoppingBasket";
import {ShoppingBasketLineItem } from "../../models/ShoppingBasketLineItem";
//import {Customer} from "../../models/Customer";
import {Address} from "../../models/Address";
import {PaymentMethod} from "../../models/PaymentMethod";
import {PaymentRequest} from "../../models/PaymentRequest";
import {ShippingRate} from "../../models/ShippingRate";
import {CartViewerTotals} from "./CartViewerTotals";
import {Panel} from "../common/Panel";
//import {CollapsiblePanel} from "../common/CollapsiblePanel";
import {Button} from "../common/Button";
import {TextBox} from "../common/TextBox";
import {CreditCardPayment} from "../common/CreditCardPayment";
//import {Address as AddressEditor} from "../common/Address";
//import {CheckoutShipping} from "./CheckoutShipping";
import {CheckoutItemReview} from "./CheckoutItemReview";
//import {CartBlackoutZones} from "./CartBlackoutZones";
import {AddressBookDialog} from "./AddressBookDialog";
//import {ModalDialog, ModalBody, ModalFooter } from "../common/ModalDialog";
import {MoneyDisplay} from "../common/MoneyDisplay";
import update = require("react-addons-update");
import ShoppingBasketStore from "../../stores/ShoppingBasketStore";
import PaymentMethodStore from "../../stores/PaymentMethodStore";
import AddressBookDialogStore from "../../stores/AddressBookDialogStore";
import { ReadonlyAddress } from "../common/ReadonlyAddress";

import FBEmitter = require("fbemitter");
export interface CheckoutProps
{
	shoppingBasket: ShoppingBasket;
	removeLineItem: (lineItem: ShoppingBasketLineItem) => void;
	adjustLineItemQty: (lineItem: ShoppingBasketLineItem, qty: number) => void;
	showShipping: boolean;
	hidePONumber?: boolean;
	allowLineItemEdits: boolean;
	lockShippingAddress: boolean;
	termsText?: string;
	termsLink?: string;
	skipRedirectToOrderConfirmation: boolean;
	shippingRequiresPhoneNumber?: boolean;
	billingRequiresPhoneNumber?: boolean;
	onCheckoutSuccess?:(orderId:string)=> void;
	isAnonEnabled: boolean;
}

//<select class="form-control">
//	<option>Select Payment Method</option>
//	<option value="5186D8D968585543388B88D2">American Express</option>
//	<option value="5186D8F968585543388B88D5">MasterCard</option>
//	<option value="5186D90168585543388B88D6">VISA</option>
//	<option value="5186D90C68585543388B88D7">Cash</option>
//</select >

export interface CheckoutState
{
	paymentMethods: Array<PaymentMethod>;
	selectedPaymentMethod?: PaymentMethod;
	selectedShippingRate?: ShippingRate;
	shippingAccountNumber?: string;
	selectedShippingAddress?: Address;
	selectedBillingAddress?: Address;
	selectedEmailAddress?: string;
	billingSameAsShipping: boolean;
	isTaxExempt: boolean;
	notes: string;
	poNumber: string;
	promoCode: string;
	paymentRequest: PaymentRequest;
	poRequired: boolean;
	validationState: ValidationState;	
	shouldValidate: boolean;
}
export interface ValidationState{
	shippingAddressValid: boolean;
		shippingAddressEmpty: boolean;
		billingAddressEmpty: boolean;
		billingAddressValid: boolean;
		paymentDataValid: boolean;
		shippingValid: boolean;
		emailValid: boolean;
		isValid: boolean;
		poRequired:boolean;
		errors:string[];
}
export class Checkout extends React.Component<CheckoutProps, CheckoutState>
{
	private paymentMethodStore: FBEmitter.EventSubscription;

	state: CheckoutState =
	{
		paymentMethods: [],
		isTaxExempt: false,
		notes: "",
		poNumber: "",
		promoCode: "",
		billingSameAsShipping: false,
		paymentRequest: new PaymentRequest(),
		selectedEmailAddress: this.props.shoppingBasket.customer ? this.props.shoppingBasket.customer.emailAddress : "",
		poRequired: false,
		validationState: {
			shippingAddressValid: true,
			billingAddressEmpty: false,
			shippingAddressEmpty: false,
			billingAddressValid: true,
			paymentDataValid: true,
			emailValid: true,
			shippingValid: false,
			isValid: false,
			poRequired:false,
			errors:[]
		},
		
		shouldValidate: false
	};

	static defaultProps =
	{
		termsText: "By placing your order, you agree to our terms of use",
		shippingRequiresPhoneNumber:true,
		billingRequiresPhoneNumber:true
	}

	componentDidMount()
	{
		this.paymentMethodStore = PaymentMethodStore.addListener(this.paymentMethodsUpdated.bind(this));
		PaymentMethodStore.loadPaymentMethods();
		this.setInitialAddressState(null);
		this.checkPromoCode();
	}

	private checkPromoCode()
	{
		let basket = this.props.shoppingBasket;
		if (basket)
		{
			let code = basket.promoCode;
			this.setState(update(this.state,
				{
					$set: {
						promoCode: code
					}
				}));
		}

	}

	componentWillReceiveProps(nextProps: CheckoutProps)
	{
		this.setInitialAddressState(nextProps);
		this.setState(update(this.state,
			{
				$set: {
					selectedEmailAddress: nextProps.shoppingBasket.customer ? nextProps.shoppingBasket.customer.emailAddress : "",
					promoCode: nextProps.shoppingBasket.promoCode
				}
			}));
	}

	componentDidUnMount()
	{
		this.paymentMethodStore.remove();
	}

	private isFreeBasket() {
		return this.props.shoppingBasket.grandTotal == 0;
	}

	private paymentMethodsUpdated()
	{
		// Filter "cash" (5186D90C68585543388B88D7) out of the list because we can't allow it to be bound as a payment method
		// in the methods dropdown
		this.setState(update(this.state, { $set: { paymentMethods: PaymentMethodStore.getPaymentMethods().filter((element) => element.id != "5186D91B68585543388B88D9") } }));
	}

	private getPoPaymentMethod()
	{
		var cashMethod = new PaymentMethod();
		cashMethod.id = "5186D91B68585543388B88D9";
		cashMethod.isInstant = false;
		cashMethod.name = "Purchase Order";
		return cashMethod;
	}

	//private selectShippingRate(rate: ShippingRate)
	//{
	//	this.setState(update(this.state, { $set: { selectedShippingRate: rate } }));
	//	ShoppingBasketStore.setShippingRate(rate);
	//}

	//private setShippingAccountNumber(accountNumber: string)
	//{
	//	this.setState(update(this.state, { $set: { shippingAccountNumber: accountNumber } }));
	//	ShoppingBasketStore.setShippingAccountNumber(accountNumber);
	//}

	private setInitialAddressState(props: CheckoutProps)
	{
		var shoppingBasket = props ? props.shoppingBasket : this.props.shoppingBasket;
		var validationState =
			{
				shippingAddressValid: true,
				billingAddressValid: true,
				shippingAddressEmpty: false,
				billingAddressEmpty: false,
				paymentDataValid: this.state.validationState.paymentDataValid,
				shippingValid: this.state.validationState.shippingValid,
				emailValid: this.state.validationState.emailValid,
				isValid: false,
				errors:this.state.validationState.errors
			};
		var customerhasNoAddresses = shoppingBasket.customer ? shoppingBasket.customer.addresses.length === 0 : false;
		var shippingIsValid = this.validateAddress(shoppingBasket.selectedShippingAddress, true);
		var billingIsValid = this.validateAddress(shoppingBasket.selectedBillingAddress, false);
		validationState.billingAddressEmpty = customerhasNoAddresses || billingIsValid.isEmpty;
		validationState.billingAddressValid = customerhasNoAddresses || billingIsValid.isValid;
		validationState.shippingAddressEmpty = customerhasNoAddresses || shippingIsValid.isEmpty;
		validationState.shippingAddressValid = customerhasNoAddresses || shippingIsValid.isValid;
		// There should only ever be one shipping rate. Force the value, if possible.
		var availableShipping = shoppingBasket.quotedShippingRates;
		var forceShipping = availableShipping.length > 0 ? availableShipping[0] : null;
		var defaultPaymentMethod = this.isFreeBasket() ? this.getPoPaymentMethod() : this.state.selectedPaymentMethod;
		var forcePoNum = this.isFreeBasket() ? "X" : "";
		this.setState(update(this.state,
			{
				$set: {
					selectedShippingAddress: shoppingBasket.selectedShippingAddress,
					selectedBillingAddress: shoppingBasket.selectedBillingAddress,
					//selectedShippingRate: shoppingBasket.selectedShippingRate,
					selectedShippingRate: forceShipping,
					selectedPaymentMethod: defaultPaymentMethod,
					poNumber: forcePoNum,
					shippingAccountNumber: shoppingBasket.shippingAccountNumber,
					validationState: validationState
				}
			}));
	}

	private checkIfLoggedOut()
	{
		if (!this.props.isAnonEnabled)
			return window.username === "" || !window.username;
	}

	private isLoggedInAnonMode()
	{
		return window.username !== "" && window.username;
	}

	render()
	{
		var didLogOut = this.checkIfLoggedOut();
		if (didLogOut)
		{
			return <h3>Your Shopping Cart is empty</h3>;
		}
		//let promoError = ShoppingBasketStore.getPromoError();
		//var promoCode = this.props.shoppingBasket.promoCode;
		//let shippingRequired: JSX.Element = null;
		//let billingRequired: JSX.Element = null;
		let shippingRateRequired: JSX.Element = null;
		//let paymentRequired: JSX.Element = null;
		//let shippingAddress: JSX.Element = null;
		//let billingAddress: JSX.Element = null;
		//let shippingPhoneRequired = (this.props.shippingRequiresPhoneNumber !== null && this.props.shippingRequiresPhoneNumber !== undefined) ? this.props.shippingRequiresPhoneNumber : true;
		let billingPhoneRequired = (this.props.billingRequiresPhoneNumber !== null && this.props.billingRequiresPhoneNumber !== undefined) ? this.props.billingRequiresPhoneNumber : true;
		//if (!this.state.validationState.paymentDataValid)
		//{
		//	paymentRequired = <span className="text-danger bg-danger">Payment Information is required</span>;
		//}
		//if (this.state.validationState.shippingAddressEmpty || !this.state.validationState.shippingAddressValid)
		//{
		//	shippingRequired = <span className="text-danger bg-danger">
		//		No shipping address selected, Press the change button to select or create a new address
		//	</span>;
		//} else
		//{
		//	shippingAddress = <ReadonlyAddress address={this.props.shoppingBasket.selectedShippingAddress}/>;
		//}

		//if (this.state.validationState.billingAddressEmpty || !this.state.validationState.billingAddressValid)
		//{
		//	billingRequired = <div>
		//		<span className="text-danger bg-danger">
		//			No billing address selected, Press the change button to select or create a new address
		//		</span>
		//		<p>&nbsp; </p>
		//	</div>;
		//} else
		//{
		//	billingAddress = <ReadonlyAddress address={this.props.shoppingBasket.selectedBillingAddress}/>;
		//}

		if (!this.state.selectedShippingRate)
		{
			shippingRateRequired = <span className="text-danger bg-danger">Shipping Rate is required</span>;
		}
		var config = this.props.shoppingBasket.configuration;
		//var shippingTitle = config.isAnonymousCheckoutEnabled
		//	? (this.isLoggedInAnonMode() ? "1\u00A0\u00A0\u00A0\u00A0 Shipping" : "2\u00A0\u00A0\u00A0\u00A0 Shipping")
		//	: "1\u00A0\u00A0\u00A0\u00A0 Shipping";
		//var paymentTitle = config.isAnonymousCheckoutEnabled
		//	? (this.isLoggedInAnonMode() ? "2\u00A0\u00A0\u00A0\u00A0 Payment" : "3\u00A0\u00A0\u00A0\u00A0 Payment")
		//	: "2\u00A0\u00A0\u00A0\u00A0 Payment";
		//var reviewTitle = config.isAnonymousCheckoutEnabled
		//	? (this.isLoggedInAnonMode() ? "3\u00A0\u00A0\u00A0\u00A0 Review items" : "4\u00A0\u00A0\u00A0\u00A0 Review items")
		//	: "3\u00A0\u00A0\u00A0\u00A0 Review items";
		var reviewTitle = "";
		if (this.isFreeBasket()) {
			reviewTitle = "2\u00A0\u00A0\u00A0\u00A0 Review items";
		} else {
			reviewTitle = config.isAnonymousCheckoutEnabled
				? (this.isLoggedInAnonMode() ? "2\u00A0\u00A0\u00A0\u00A0 Review items" : "3\u00A0\u00A0\u00A0\u00A0 Review items")
				: "2\u00A0\u00A0\u00A0\u00A0 Review items";
		}
		//var addNotesTitle = config.isAnonymousCheckoutEnabled
		//	? (this.isLoggedInAnonMode() ? "4\u00A0\u00A0\u00A0\u00A0 Additional notes or comments" : "5\u00A0\u00A0\u00A0\u00A0 Additional notes or comments")
		//	: "4\u00A0\u00A0\u00A0\u00A0 Additional notes or comments";

		return <div>
			<div className="row checkout">
				<div className="col-md-8">
					{this.renderEmail()}
					{this.renderShippingBlock()}
					{this.renderBillingBlock()}
					<Panel title={reviewTitle}>
						<CheckoutItemReview shoppingBasket={this.props
							.shoppingBasket} removeLineItem={this.props.removeLineItem} adjustLineItemQty={this.props
								.adjustLineItemQty}
							allowLineItemEdits={this.props.allowLineItemEdits}/>
					</Panel>
				{/*	<Panel title={addNotesTitle}>*/}
				{/*		<textarea className="form-control" rows={3} onChange={this.handleNotes.bind(this) } value={this*/}
				{/*			.state.notes}/>*/}
				{/*	</Panel>*/}
				</div>
				<div className="col-md-4 text-center">
					<div className="well affix">
						<h3>Order Summary</h3>
						<CartViewerTotals shoppingBasket={this.props.shoppingBasket} showShipping={this.props
							.showShipping}/>
					</div>
				</div>

				{/*<AddressBookDialog title="Change Shipping Address" shoppingBasket={this.props*/}
				{/*	.shoppingBasket} phoneRequired={shippingPhoneRequired} addressType={"ship"}/>*/}
				<AddressBookDialog title="Change Billing Address" shoppingBasket={this.props
					.shoppingBasket} phoneRequired={billingPhoneRequired} addressType={"bill"}/>
			</div>
			<div className="row">
				<div className="col-xs-12">
					<div className="well">
						<div className="row">
							<div className="col-sm-7 col-xs-12 col-md-3">
								<Button label="Place your order" onClick={this.processPayment.bind(this) }/>
							</div>
							<div className="col-sm-4 col-xs-12 col-md-9 text-left">
								<h3 className="order-total">
									Order total: <MoneyDisplay amount={this.props.shoppingBasket.grandTotal}/>
								</h3>
								{this.renderTermsLink() }

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}

	private renderShippingBlock() {
		return null;
		{/*<Panel title={shippingTitle}>*/ }
		{/*	<h4>Shipping Address</h4>*/ }
		{/*	<div className="row">*/ }
		{/*		<div className="col-xs-6">*/ }
		{/*			{shippingAddress}*/ }
		{/*			{shippingRequired}*/ }
		{/*		</div>*/ }
		{/*		{ this.renderShippingChangeButton() }*/ }
		{/*	</div>*/ }
		{/*	<h4>Shipping Method</h4>*/ }
		{/*	<CheckoutShipping shoppingBasket={this.props.shoppingBasket} onRateSelected={this.selectShippingRate*/ }
		{/*		.bind(this) } onShippingAccountNumberChange={this.setShippingAccountNumber.bind(this) }/>*/ }
		{/*	{shippingRateRequired}*/ }
		{/*	<CartBlackoutZones shoppingBasket={this.props.shoppingBasket}/>*/ }
		{/*</Panel>*/ }
	}

	private renderBillingBlock() {
		// Don't show a billing section if we're not actually charging any money
		if (this.isFreeBasket()) return null;

		var config = this.props.shoppingBasket.configuration;
		var paymentTitle = config.isAnonymousCheckoutEnabled
			? (this.isLoggedInAnonMode() ? "1\u00A0\u00A0\u00A0\u00A0 Payment" : "2\u00A0\u00A0\u00A0\u00A0 Payment")
			: "1\u00A0\u00A0\u00A0\u00A0 Payment";

		let paymentRequired: JSX.Element = null;
		let billingRequired: JSX.Element = null;
		let billingAddress: JSX.Element = null;

		if (!this.state.validationState.paymentDataValid) {
			paymentRequired = <span className="text-danger bg-danger">Payment Information is required</span>;
		}

		if (this.state.validationState.billingAddressEmpty || !this.state.validationState.billingAddressValid) {
			billingRequired = <div>
				<span className="text-danger bg-danger">
					No billing address selected, Press the change button to select or create a new address
				</span>
				<p>&nbsp; </p>
			</div>;
		} else {
			billingAddress = <ReadonlyAddress address={this.props.shoppingBasket.selectedBillingAddress} />;
		}

		return <Panel title={paymentTitle}>
			<h4>Billing Address</h4>
			{/*<div className="checkbox">*/}
			{/*	<label>*/}
			{/*		<input type="checkbox" name="billingSameAsShipping" value={this.state.billingSameAsShipping*/}
			{/*			.toString()} onClick={this.handleBillingSameAsShipping.bind(this)} />*/}
			{/*		Billing same as shipping*/}
			{/*	</label>*/}
			{/*</div>*/}
			<div className="row">
				<div className="col-xs-6">
					{billingAddress}
					{billingRequired}
				</div>
				{this.renderBillingChangeButton()}
			</div>
			{/*{this.renderPromoCode(promoCode, promoError)}*/}
			<h4>Payment Method</h4>
			<div className="form-group">
				{this.renderPaymentMethods()}
			</div>
			{this.renderPONumber()}
			{this.renderCreditCard()}
			{paymentRequired}
			{/* {this.renderTaxExemption()} */}
		</Panel>
	}

	private renderTermsLink()
	{
		if (this.props.termsLink)
		{
			return <small><a href={this.props.termsLink} target="_blank" rel="noopener">{this.props.termsText}</a></small>;
		}
		return <small>{this.props.termsText}</small>;
	}

	private renderPONumber()
	{
		if (this.props.hidePONumber)
			return null;
		return <TextBox fieldName="PurchaseOrder" label="Purchase Order Number" value={this.state
			.poNumber} isRequired={this.state
				.poRequired} requiredMessage={"This field is required"} onChange={this.handlePoNumber.bind(this) }/>;
	}
	// private renderShippingChangeButton()
	// {
	// 	if (this.props.lockShippingAddress)
	// 	{
	// 		return null;
	// 	}

	// 	return <div className="col-xs-6 text-right">
	// 		<Button label="Change" onClick={() =>
    //         {
	// 			AddressBookDialogStore.openDialog("ship", true);
    //         } }/>
	// 	</div>;
	// }

	// private renderPromoCode(promoCode: string, promoError:string)
	// {
	// 	var promo = null;
	// 	if (promoCode)
	// 	{
	// 		promo = <div className="col-md-7 col-lg-7">
	// 				<label>Promo Code</label>
	// 				<p>{promoCode}</p>			
	// 				</div>;
	// 	}
	// 	else
	// 	{
	// 		promo =  <div className="col-md-7 col-lg-7">
	// 				<TextBox fieldName="PromoCode" label="Promo Code"
	// 					value={this.state.promoCode}
	// 					onChange={this.handlePromoCode.bind(this)} />
	// 					{promoError === "" ? null :
	// 						<p className="text-danger">{promoError}</p>}		
	// 		</div>;
	// 	}
	// 	return <div className="row promo-code">
	// 			{promo}
	// 			<div className="col-xs-6 col-md-4 col-lg-4 text-right">
	// 				<Button label={promoCode === "" ? "Apply" : "Remove"} 
	// 					onClick={promoCode === "" ? this.addPromoCode.bind(this) : this.removePromoCode.bind(this) }/>
	// 			</div>		
	// 	</div>;
	// }

	private renderBillingChangeButton()
	{
		if (this.state.billingSameAsShipping)
		{
			return null;
		}

		return <div className="col-xs-6 text-right">
			<Button label="Change" onClick={() =>
            {
				AddressBookDialogStore.openDialog("bill", true);
            } }/>
		</div>;
	}

	// private renderTaxExemption()
	// {
	// 	var config = this.props.shoppingBasket.configuration;
	// 	var taxExemptionmessage = config.taxExemptMessage;
	// 	if (!config.isTaxExemptEnabled)
	// 	{
	// 		return null;
	// 	}
	// 	return <div className="form-group tax-exempt-block">
	// 		<h4>Tax Exempt</h4>
	// 		<div className="checkbox">
	// 			<label>
	// 				<input type="checkbox" name="taxExempt" value={this.state.isTaxExempt.toString() } onClick={this
	// 					.handleTaxExempt.bind(this) }/>
	// 				{taxExemptionmessage}
	// 			</label>
	// 		</div>
	// 	</div>;
	// }

	private renderEmail()
	{
		var config = this.props.shoppingBasket.configuration;
		var isAnon = config.isAnonymousCheckoutEnabled;
		if (!isAnon || (window.username !== "" && window.username))
		{
			return null;
		}
		var panelTitle = "1\u00A0\u00A0\u00A0\u00A0 Email address";
		return <Panel title={panelTitle}>
			<div className="row">
				<div className="col-xs-6">
					<TextBox
						label={"Email"}
						value={this.props.shoppingBasket.customer.emailAddress}
						onBlur={ this.updateEmail.bind(this) }
						placeholder={"email address"}
						fieldName={"email-address"}
						isRequired={this.state.shouldValidate}
						requiredMessage={"This field is required"}/>
				</div>
			</div>
		</Panel>;
	}
	private addError(error:string)
	{
		var errors = this.state.validationState.errors.slice();
		errors.push(error);
		this.setState(update(this.state,{$set:{"validationState.errors":errors}}));
	}
	private clearErrors()
	{
		this.setState(update(this.state,{$set:{errors:[]}}));
	}
	private updateEmail(ev: React.FormEvent<any>)
	{
		var email = ev.target.value;
		if(!email)
			this.addError("Missing Email Address");
		this.setState(update(this.state, { $set: { selectedEmailAddress: email } }));
		ShoppingBasketStore.setEmailAddressForAnon(email);
	}

	private renderPaymentMethods()
	{
		return <select className="form-control" onChange={this.selectPaymentMethod.bind(this) }>
			<option>Select Payment Method</option>
			{this.state.paymentMethods.map((method) =>
            {
				return <option key={method.id} value={method.id}>{method.name}</option>;
            }) }
		</select>;
	}

	private renderCreditCard()
	{
		if (this.state.selectedPaymentMethod != null && this.state.selectedPaymentMethod.isInstant)
		{
			return <CreditCardPayment shouldTriggerVaidation={this.state
				.shouldValidate} fieldName="creditCard" paymentRequestUpdated={this.handleCreditCard
					.bind(this) } selectedPaymentMethod={this.state.selectedPaymentMethod.id}/>;
		}
		return null;
	}

	private selectPaymentMethod(ev: React.FormEvent<any>)
	{
		if (ev.target.value && (ev.target.value as string).length > 0)
		{
			const id = ev.target.value as string;
			const methods = this.state.paymentMethods;
			for (let i = 0; i < methods.length; i++)
			{
				const method = methods[i];
				if (method.id === id)
				{
					this.setState(update(this.state, { $set: { selectedPaymentMethod: method } }));
					return;
				}
			}
		}
	}

	handleTaxExempt(ev: React.FormEvent<any>)
	{
		const checkbox = ev.target as HTMLInputElement;
		this.setState(update(this.state, { $set: { isTaxExempt: checkbox.checked } }));
	};

	// handleBillingSameAsShipping(ev: React.FormEvent<any>)
	// {
	// 	const checkbox = ev.target as HTMLInputElement;
	// 	var validBilling = this.validateAddress(this.state.selectedShippingAddress,false);
	// 	if (!checkbox.checked)
	// 	{
	// 		this.setState(update(this.state, { $set: { billingSameAsShipping: false } }));
	// 		return;
	// 	}
	// 	if (validBilling.isValid)
	// 	{
	// 		this.setState(update(this.state, { $set: { billingSameAsShipping: checkbox.checked } }));
	// 		ShoppingBasketStore.assignPerferredAddress(this.state.selectedShippingAddress, "bill").done((basket: ShoppingBasket) =>
	// 		{
	// 			this.setState(update(this.state, { $set: { selectedBillingAddress: basket.selectedBillingAddress } }));
	// 		});
	// 	}
	// 	else
	// 	{
	// 		let valState = this.state.validationState;
	// 		valState.billingAddressValid = false;
	// 		this.setState(update(this.state,
	// 			{ $set: { validationState: valState, shouldValidate: true } }));
	// 		alert("Your shipping address does not include a phone number which is required for billing.  Please create or select another address.");
	// 	}
	// }

	// handleNotes(ev: React.FormEvent<any>)
	// {
	// 	this.setState(update(this.state, { $set: { notes: ev.target.value } }));
	// }

	handlePoNumber(ev: React.FormEvent<any>)
	{
		this.validatePoForPaymentStatus(ev);
	}

	// handlePromoCode(ev: React.FormEvent<any>)
	// {
	// 	this.setState(update(this.state, { $set: { promoCode: ev.target.value } }));
	// }

	// addPromoCode()
	// {
	// 	var code = this.state.promoCode;
	// 	ShoppingBasketStore.addPromoCode(code);
	// }

	// removePromoCode()
	// {
	// 	ShoppingBasketStore.removePromoCode();
	// }

	handleCreditCard(paymentRequest: PaymentRequest)
	{
		this.validateCreditCardForPaymentStatus(paymentRequest);
	}

	private validatePoForPaymentStatus(ev: React.FormEvent<any>)
	{
		var value = ev.target.value;
		var validationState =
			{
				shippingAddressValid: this.state.validationState.shippingAddressValid,
				billingAddressValid: this.state.validationState.billingAddressValid,
				shippingAddressEmpty: this.state.validationState.shippingAddressEmpty,
				billingAddressEmpty: this.state.validationState.billingAddressEmpty,
				paymentDataValid: false,
				shippingValid: this.state.validationState.shippingValid,
				emailValid: this.state.validationState.emailValid,
				isValid: false,
				errors:this.state.validationState.errors
			};
		var isPOValid = this.validatePo(value);
		validationState.paymentDataValid = isPOValid;
		this.setState(update(this.state, { $set: { poNumber: value, validationState: validationState } }));
	}

	private validateCreditCardForPaymentStatus(paymentRequest: PaymentRequest)
	{
		var validationState =
			{
				shippingAddressValid: this.state.validationState.shippingAddressValid,
				billingAddressValid: this.state.validationState.billingAddressValid,
				shippingAddressEmpty: this.state.validationState.shippingAddressEmpty,
				billingAddressEmpty: this.state.validationState.billingAddressEmpty,
				emailValid: this.state.validationState.emailValid,
				paymentDataValid: false,
				shippingValid: this.state.validationState.shippingValid,
				isValid: false,
				errors: this.state.validationState.errors
			};
		var isCCValid = this.validateCC(paymentRequest);
		validationState.paymentDataValid = isCCValid;
		this.setState(update(this.state, { $set: { paymentRequest: paymentRequest, validationState: validationState } }));
	}

	private validateAddress(address: Address, isShipping: boolean): any
	{
		if (!address)
		{
			return false;
		}
		var isMainValid = this.isValidString(address.line1) &&
			this.isValidString(address.city) &&
			this.isValidString(address.stateProvince) &&
			this.isValidString(address.postalCode) &&
			this.isValidString(address.country);
		var isNameValid = false;
		var isPhoneValid = true;
		if (address.person === null || address.person === undefined)
		{
			isNameValid = false;
		} else
		{
			isNameValid = this.isValidString(address.person.first) && this.isValidString(address.person.last);
		}
		if (isShipping)
		{
			let shouldCheck = (this.props.shippingRequiresPhoneNumber !== null && this.props.shippingRequiresPhoneNumber !== undefined) ?
				this.props.shippingRequiresPhoneNumber : false;
			if (shouldCheck)
			{
				isPhoneValid = this.isValidString(address.phoneNumber);
			}
		}
		else
		{
			let shouldCheck = (this.props.billingRequiresPhoneNumber !== null && this.props.billingRequiresPhoneNumber !== undefined) ?
				this.props.billingRequiresPhoneNumber : true;
			if (shouldCheck)
			{
				isPhoneValid = this.isValidString(address.phoneNumber);
			}
		}

		var isValid = isMainValid && isPhoneValid && isNameValid;
		var isMainEmpty = this.isEmptyString(address.line1) &&
			this.isEmptyString(address.city) &&
			this.isEmptyString(address.stateProvince) &&
			this.isEmptyString(address.postalCode) &&
			this.isEmptyString(address.country);
		var isNameEmpty = false;
		if (address.person === null || address.person === undefined)
		{
			isNameEmpty = true;
		} else
		{
			isNameEmpty = this.isEmptyString(address.person.first) && this.isEmptyString(address.person.last);
		}

		var isPhoneEmpty = false;
		if (isShipping)
		{
			let shouldCheck = (this.props.shippingRequiresPhoneNumber !== null && this.props.shippingRequiresPhoneNumber !== undefined) ?
				this.props.shippingRequiresPhoneNumber : false;
			if (shouldCheck)
			{
				isPhoneEmpty = this.isEmptyString(address.phoneNumber);
			}
		}
		else
		{
			let shouldCheck = (this.props.shippingRequiresPhoneNumber !== null && this.props.shippingRequiresPhoneNumber !== undefined) ?
				this.props.shippingRequiresPhoneNumber : true;
			if (shouldCheck)
			{
				isPhoneEmpty = this.isEmptyString(address.phoneNumber);
			}
		}

		var isEmpty = isMainEmpty && isPhoneEmpty;
		var validation = { isValid: isValid, isEmpty: isEmpty };
		return validation;
	}

	private isValidString(stringToCheck: string, isEmail:boolean = false)
	{
		if (isEmail)
			return stringToCheck !== "" && stringToCheck !== undefined && stringToCheck !== null && stringToCheck.indexOf("@") !== -1;
		return stringToCheck !== "" && stringToCheck !== undefined && stringToCheck !== null;
	}

	private isEmptyString(stringToCheck: string)
	{
		return stringToCheck === "" || stringToCheck === undefined || stringToCheck === null;
	}

	private processPayment()
	{
		this.clearErrors();
		var isValid = this.validate();
		this.setState(update(this.state,{$set:{validationState:isValid}}));
		if (!isValid.isValid)
		{
			this.setState(update(this.state,
				{ $set: { validationState: isValid, poRequired: isValid.poRequired, shouldValidate: true } }));
			var errorStr = isValid.errors.join("\n");
			alert("Please correct the following errors and try again \n" + errorStr);
			return null;
		}
		this.setState(update(this.state, { $set: { validationState: isValid } }));
		var paymentRequest = this.state.paymentRequest;
		var notes = this.state.notes;
		var isTaxExempt = this.state.isTaxExempt;
		paymentRequest.paymentMethodId = this.state.selectedPaymentMethod.id;
		paymentRequest.accountType = this.state.selectedPaymentMethod.name;
		paymentRequest.poNumber = this.state.poNumber;
		paymentRequest.accountNumber = paymentRequest.accountNumber.replace(/\s+/g, "");
		return ShoppingBasketStore.performCheckout(paymentRequest, notes, isTaxExempt).done((orderId:string) =>
		{
			if (this.props.skipRedirectToOrderConfirmation)
			{
				if (this.props.onCheckoutSuccess)
					this.props.onCheckoutSuccess(orderId);
			}
			else
				window.location.assign(`/orderconfirmation.htm?orderid=${orderId}`);
		}).fail((fail: JQueryXHR) =>
		{
			alert(`Sorry your payment could not be processed. Please check your payment information and try again.\n\n${fail.responseJSON.exceptionMessage}`);
		});
	}

	private validatePo(value: any)
	{
		var isPOValid = value !== "";
		return isPOValid;
	}

	private validateCC(paymentRequest: PaymentRequest)
	{
		var isCCValid = paymentRequest.accountNumber !== "" &&
			paymentRequest.expirationMonth !== "" &&
			paymentRequest.expirationYear !== "" &&
			paymentRequest.expirationYear !== "" &&
			paymentRequest.verification !== "";
		return isCCValid;
	}

	private validate()
	{
		var config = this.props.shoppingBasket.configuration;
		var validationState : ValidationState =
			{
				shippingAddressValid: false,
				billingAddressValid: false,
				shippingAddressEmpty: false,
				billingAddressEmpty: false,
				paymentDataValid: false,
				shippingValid: false,
				emailValid: false,
				isValid: false,
				poRequired: false,
				errors:[]
			};

		var emailValid = config.isAnonymousCheckoutEnabled ? this.isValidString(this.state.selectedEmailAddress,true) : true;
		if (!emailValid)
		{
			validationState.emailValid == emailValid;
			validationState.errors.push("Invalid email address");
		}
		var paymentRequest = this.state.paymentRequest;
		var selectedPaymentMethod = this.state.selectedPaymentMethod;
		var isPo = selectedPaymentMethod ? selectedPaymentMethod.id === "5186D91B68585543388B88D9" : false;
		var isCash = selectedPaymentMethod ? selectedPaymentMethod.id === "5186D90C68585543388B88D7" : false;
		if (!isPo)
		{
			if (!isCash) {
				var isCCValid = this.validateCC(paymentRequest);
				validationState.paymentDataValid = isCCValid;
				if (!isCCValid)
					validationState.errors.push("Invalid credit card information");
			} else {
				validationState.paymentDataValid = true;
			}
		} else
		{
			var isPOValid = this.validatePo(this.state.poNumber);
			validationState.paymentDataValid = isPOValid;
			if(!isPOValid)
				validationState.errors.push("Invalid purchase order information");
		}

		var shippingIsValid = this.validateAddress(this.state.selectedShippingAddress, true);
		var billingIsValid = this.validateAddress(this.state.selectedBillingAddress, false);
		validationState.shippingAddressValid = shippingIsValid.isValid;
		validationState.billingAddressValid = billingIsValid.isValid;
		validationState.billingAddressEmpty = billingIsValid.isEmpty;
		validationState.shippingAddressEmpty = shippingIsValid.isEmpty;
		
		if(!validationState.shippingAddressValid)
			validationState.errors.push("Missing Shipping Address information");
		if(!validationState.billingAddressValid)
			validationState.errors.push("Missing Billing Address information");

		if (!this.state.selectedShippingRate ||
			(this.state.selectedShippingRate.isShippingAccount && this.state.shippingAccountNumber === "")||
			(this.state.selectedShippingRate.isShippingAccount && !this.state.shippingAccountNumber))
		{
			validationState.shippingValid = false;
			validationState.errors.push("Missing Shipping Account Number");
		} else
		{
			validationState.shippingValid = true;
		}
		validationState.poRequired = isPo;
		validationState.isValid = (validationState.billingAddressValid &&
			//validationState.shippingAddressValid && // We don't capture shipping address any more
			validationState.paymentDataValid &&
			validationState.shippingValid);
		return validationState;
	}
}


// WEBPACK FOOTER //
// ./src/components/shoppingbasket/Checkout.tsx